import {gql} from '@apollo/client'

export const GET_ALL_LEAD_SOURCE_CATEGORIES = gql`
  query allCategoryLeadSource(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: Float
    $name: String
    $name_Icontains: String
    $name_Istartswith: String
  ) {
    allCategoryLeadSource(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      name: $name
      name_Icontains: $name_Icontains
      name_Istartswith: $name_Istartswith
    ) {
      totalCount
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          created
          name
          leadSourceSet {
            edges {
              node {
                id
                created
                name
                enabled
                slug
                metadata
                category {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_ALL_LEAD_SOURCES = gql`
  query allLeadSources(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $name: String
    $category: String
    $enabled: Boolean
  ) {
    allLeadSources(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      name: $name
      category: $category
      enabled: $enabled
    ) {
      totalCount
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          name
          created
          enabled
          slug
          metadata
          category {
            id
            name
          }
        }
      }
    }
  }
`
